import { useSettings } from 'Settings'
import { regValues, row_content } from './ExportC'

import { TYPE } from 'configuration';

const LegacyExport = ({ className, onClick }) => {
	const [settings] = useSettings()
	const hps = settings['harvester power supervisory']
	const overwrite = settings['overwrite']
	regValues(settings, row_content)

	let dataStr = ""

	Object.entries(row_content).forEach(([key, reg]) => {
		const value = overwrite[reg.related].value ? overwrite[reg.related].value : reg.value
		dataStr += `0x${value.toString(16)}\n`
	})

	const dataUri = 'data:text/plain;charset=utf-8,' + encodeURIComponent(dataStr);

	const fileName = `config.${TYPE}`

	return (
		<a
			href={dataUri}
			download={fileName}
			className={className}
			onClick={onClick}
		>
			Legacy Export
		</a>
	)
}

export default LegacyExport
